import React from 'react';
import './styles.css';
const Header = () => {
    return (
        <header>
            <h1>My Portfolio</h1>
            <nav>
                <ul>
                    <li><a href="#about">About Me</a></li>
                    <li><a href="#projects">Projects</a></li>
                    <li><a href="#patents">Patents</a></li>
                    <li><a href="#achievements">Achievements</a></li>
                    <li><a href="#work-experience">Work Experience</a></li>
                    <li><a href="#hobbies">Hobbies</a></li>
                </ul>
            </nav>
        </header>
    );
};

export default Header;
